import script from "./TopBar.vue?vue&type=script&setup=true&lang=js"
export * from "./TopBar.vue?vue&type=script&setup=true&lang=js"

import "./TopBar.vue?vue&type=style&index=0&id=d274a9ee&scoped=true&lang=css"

import exportComponent from "C:\\work\\HIMSDeployTest\\HIMSFRONTEND\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d274a9ee"]])

export default __exports__